import { render, staticRenderFns } from "./AreaContainer.vue?vue&type=template&id=1ab2fc73"
import script from "./AreaContainer.vue?vue&type=script&lang=js"
export * from "./AreaContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports